import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import StandardButton from "./StandardButton";

const Container = styled.div`
  text-align: center;
  /* display: flex; */
  .container {
    display: flex; /* or inline-flex */
    flex-basis: auto; /* default auto */
  }
  ul {
    display: flex;
    /* align-items: stretch; */
    /* Default */
    /* justify-content: space-between; */
    /* width: 100%; */
    /* background: #cacaca; */
    /* border: 2px solid green; */

    margin: 0;
    padding: 0;
  }
  li {
    display: block;
    flex: 0 1 auto; /* Default */
    list-style-type: none;
    /* background: #fafafa; */
    padding: 20;
  }
  .item {
    order: 5; /* default is 0 */
  }
  .message {
    padding: 20px;
    color: blue;
  }
`;
const NewSubscriptionButton = () => {
  return (
    <Container>
      <ul>
        <StandardButton mxt_green> new subscription</StandardButton>
      </ul>
    </Container>
  );
};

export default NewSubscriptionButton;
